import * as React from "react";
const SvgFiRrMosquitoNet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mosquito-net_svg__a)">
      <path
        fill="#062147"
        d="M21 14h-4c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3h4c1.654 0 3-1.346 3-3v-4c0-1.654-1.346-3-3-3m1 3v1h-2v-2h1a1 1 0 0 1 1 1m-5-1h1v2h-2v-1c0-.552.45-1 1-1m-1 5v-1h2v2h-1c-.55 0-1-.448-1-1m5 1h-1v-2h2v1a1 1 0 0 1-1 1m.62-10c-.027-.052-.043-.108-.072-.159-.456-.802-1.197-1.069-2.085-1.313-1.27-.35-2.769-.527-4.45-.527h-2.035l4.99-3.55a2.5 2.5 0 0 0 1.05-2.067l-.009-.763a.5.5 0 0 1 .146-.359l1.553-1.554A.999.999 0 1 0 19.294.294l-1.553 1.553a2.51 2.51 0 0 0-.733 1.798l.01.762a.5.5 0 0 1-.21.415l-3.86 2.746a2.497 2.497 0 0 0-.69-3.727L11.512.413c-.12-.55-.904-.55-1.023 0l-.746 3.428a2.497 2.497 0 0 0-.702 3.711l-3.83-2.737A.5.5 0 0 1 5 4.408v-.786a2.52 2.52 0 0 0-.732-1.768L2.707.294a.999.999 0 1 0-1.414 1.413l1.561 1.561A.5.5 0 0 1 3 3.622v.786c0 .806.392 1.566 1.047 2.034l4.982 3.56H7c-2.285 0-3.664 0-4.462.22a3.43 3.43 0 0 0-2.085 1.62 3.42 3.42 0 0 0-.329 2.62A3.46 3.46 0 0 0 3.454 17q.454.001.913-.124c.734-.2 2.02-1.208 3.281-2.328L4.604 18.1a2.5 2.5 0 0 0-.603 1.628v1.022a.5.5 0 0 1-.2.4l-1.4 1.05a.999.999 0 1 0 1.2 1.6l1.4-1.05c.625-.47 1-1.218 1-2v-1.023c0-.119.041-.234.12-.325l3.88-4.526V19a1 1 0 1 0 2 0v-2a5 5 0 0 1 5-5zM3.836 14.948a1.452 1.452 0 0 1-.769-2.8C3.606 12 5.103 12 7 12h.458c-1.6 1.5-3.14 2.8-3.62 2.948"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mosquito-net_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMosquitoNet;
